/**
 * 请求方法
 */
import axios from 'axios'
import { Toast } from 'antd-mobile'

let instance = axios.create({
    // baseURL: '/'
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
})
instance.interceptors.request.use(config => {
    // 转换
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        if (config.data) {
            let reqData = config.data
            config.data = Object.keys(reqData).map(key => `${key}=${reqData[key]}`).join('&');
        }
    }
    return config
}, error => {
    return Promise.reject(error)
})
instance.interceptors.response.use(response => {
    if (response.status !== 200) {
        Toast.offline(`网络错误 ${response.status} ${response.statusText}`)
        return Promise.reject(response)
    } else {
        return response.data
    }
}, error => {
    return Promise.reject(error)
})
export default instance